module.exports = __webpack_public_path__ + "static/media/logo-whatsapp.96d49fa9.png";